module.exports = __webpack_public_path__ + "static/img/82.539e409.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/82.png
// module id = YZrn
// module chunks = 1